import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppFeatures } from '../core/config/app-config.model';
import { ConfigService } from '../core/config/config.service';

/** Libera a rota só se a flag `features.<nome>` estiver ligada; caso contrário redireciona a /home. */
export function featureGuard(feature: keyof AppFeatures): CanActivateFn {
  return () =>
    inject(ConfigService).settings()?.features?.[feature] === true
      ? true
      : inject(Router).createUrlTree(['/home']);
}
